import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FormlyFieldConfig } from "@ngx-formly/core";

export function dataProtectionFallbackFields(): FormlyFieldConfig[] {
    return [
        {
            fieldGroupClassName: 'flex flex-wrap',
            props: {
                label: _("address-group.address-group"),
                translate: true
            },
            fieldGroup: [
                {
                    className: "w-full",
                    fieldGroupClassName: "column",
                    fieldGroup: [
                        {
                            className: "w-full",
                            fieldGroupClassName: "flex flex-wrap",
                            fieldGroup: [
                                {
                                    key: 'dataProtectionSent',
                                    className: "w-full md:w-1/2",
                                    type: 'checkbox',
                                    props: {
                                        indeterminate: false,
                                        label: _('data-protection.data-protection-sent'),
                                        translate: true,
                                        attributes: {
                                            "data-testid": "data-protection-sent"
                                        }
                                    },
                                },
                                {
                                    key: 'noDirectAdvertising',
                                    className: "w-full md:w-1/2",
                                    type: 'checkbox',
                                    props: {
                                        indeterminate: false,
                                        label: _('data-protection.no-direct-advertising'),
                                        translate: true,
                                        attributes: {
                                            "data-testid": "no-direct-advertising"
                                        }
                                    },
                                },
                                {
                                    key: 'lastDataProtectionSentAt',
                                    className: "w-full md:w-1/2",
                                    type: 'formly-date-picker',
                                    props: {
                                        label: _('data-protection.last-data-protection-sent-at'),
                                        translate: true,
                                        attributes: {
                                            "data-testid": "last-data-protection-sent-at"
                                        }
                                    },
                                    wrappers: ["simple-title"],
                                },
                                {
                                    key: 'informationObtainedAt',
                                    className: "w-full md:w-1/2",
                                    type: 'formly-date-picker',
                                    props: {
                                        label: _('data-protection.information-obtained-at'),
                                        translate: true,
                                        attributes: {
                                            "data-testid": "information-obtained-at"
                                        }
                                    },
                                    wrappers: ["simple-title"],
                                },
                                {
                                    key: 'originOfInformation',
                                    className: "w-full md:w-1/2",
                                    type: 'input',
                                    props: {
                                        label: _('data-protection.origin-of-information'),
                                        translate: true,
                                        attributes: {
                                            "data-testid": "origin-of-information"
                                        }
                                    },
                                    wrappers: ["simple-title"]
                                }
                            ]
                        },
                        {
                            className: "w-full",
                            fieldGroupClassName: "flex flex-wrap",
                            fieldGroup: [
                                {
                                    key: 'note',
                                    className: "w-full",
                                    type: 'textarea',
                                    props: {
                                        rows: 3,
                                        label: _('common.note'),
                                        translate: true,
                                        attributes: {
                                            "data-testid": "data-protection-note"
                                        }
                                    },
                                }
                            ]
                        },
                        {
                            className: "w-full",
                            fieldGroupClassName: "flex flex-wrap",
                            fieldGroup: [
                                {
                                    // key: '',
                                    className: "w-full",
                                    type: 'formly-data-protection-asset-manager',
                                    props: {
                                        required: false,
                                        attributes: {
                                            'data-testid': "formly-address-data-protection-asset"
                                        }
                                    },
                                }
                            ]
                        }
                    ]
                }
            ]
        },
    ]
}



